import { useWindowSize } from "@/utils/hooksUtils";
import { cssVariables } from "@/utils/utils";
import { DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH } from "../../../../../utils";

export const StatDivider = () => {
  const windowSize = useWindowSize();

  return (
    <div
      style={{
        borderRight: `1px solid ${cssVariables.colorHover}`,
        margin: windowSize.innerWidth >= DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH ? "8px 16px 0" : "8px 10px 0",
        height: "70%",
      }}
    />
  );
};
